export default {
  title: 'Admin Panel',
  subtitle: 'Manage administration options',
  user_management: 'User Management',
  user_management_desc: 'Manage users and impersonate for troubleshooting.',

  // Impersonation
  impersonation: {
    banner: {
      title: 'Impersonating: {{userName}}',
      subtitle: 'You are currently acting as this user',
      end_button: 'End Impersonation'
    },
    button: {
      impersonate: 'Impersonate',
      you: 'You',
      tooltip_self: 'Cannot impersonate yourself',
      tooltip_impersonate: 'Impersonate {{userName}}'
    },
    confirm: {
      title: 'Confirm Impersonation',
      message: 'Are you sure you want to impersonate {{userName}}?\n\nThis will temporarily switch your session to act as this user.'
    },
    messages: {
      started: 'Impersonation started successfully',
      ended: 'Impersonation ended successfully',
      start_failed: 'Failed to start impersonation',
      end_failed: 'Failed to end impersonation'
    }
  },

  // User management
  users: {
    name: 'Display Name',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    created_at: 'Created',
    active: 'Active',
    inactive: 'Inactive',
    search_placeholder: 'Search users...',
    no_users: 'No users found',
    load_failed: 'Failed to load users',
    edit_user: 'Edit user',
    editTitle: 'Edit User',
    editSubtitle: 'Modify user settings and permissions',
    basic_info: 'Basic Information',
    is_active: 'Active User'
  },

  // Roles
  roles: {
    user: 'User',
    admin: 'Admin',
    super_admin: 'Super Admin'
  },

  // Permissions
  permissions: {
    title: 'Permissions',
    add: 'Add Permission',
    grant: 'Grant Permission',
    revoke: 'Revoke Permission',
    type: 'Permission Type',
    target_location: 'Target Location',
    target_user: 'Target User',
    notes: 'Notes',
    select_type: 'Select permission type',
    all_locations: 'All locations',
    all_users: 'All users',
    granted: 'Permission granted successfully',
    revoked: 'Permission revoked successfully',
    grant_failed: 'Failed to grant permission',
    revoke_failed: 'Failed to revoke permission'
  }
};
